export default "__VITE_ASSET__CvOatoK8__"